var matched, browser;
jQuery.uaMatch = function( ua ) {
  ua = ua.toLowerCase();
  var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
    /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
    /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
    /(msie) ([\w.]+)/.exec( ua ) ||
    ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
    [];
  return {
    browser: match[ 1 ] || "",
    version: match[ 2 ] || "0"
  };
};
matched = jQuery.uaMatch( navigator.userAgent );
browser = {};
if ( matched.browser ) {
  browser[ matched.browser ] = true;
  browser.version = matched.version;
}
// Chrome is Webkit, but Webkit is also Safari.
if ( browser.chrome ) {
  browser.webkit = true;
} else if ( browser.webkit ) {
  browser.safari = true;
}
jQuery.browser = browser;

jQuery(function ($) {
	const { jsPDF } = window.jspdf;
	Date.prototype.addDays = function (days) { //2018, and still date handling in JS is a crime against programming...
		var date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		return date;
	}

	var calendar;
	if (localStorage.getItem('pulse_calendar')) {
		calendar = JSON.parse(localStorage.getItem('pulse_calendar'));
		if (new Date(calendar.dtStart).addDays(16) < new Date()) {
			//it's been more than 14 days (plus margin for lateness) since the schedule started, so clear everything
			localStorage.removeItem('pulse_calendar');
			calendar = {
				dtStart: new Date().toISOString(),
				dtLastSave: new Date().toISOString(),
				days: []
			};
		}
	}

	var $daySection = $('.pulseCalendar__section');//.hide();
	var $buttonDiv = $('.pulseCalendar__buttons');
	for (var i = 2; i <= 14; i++) {
		var $clone = $daySection.clone();
		$clone.find('.js-day-number').text(i);
		$clone.find('input[name="morgon"]').attr('name', 'morgon_' + i);
		$clone.find('input[name="kvall"]').attr('name', 'kvall_' + i);
		if (calendar && calendar.days.length === i) {//show it if this is the last day filled
			$daySection.removeClass('active');
			$clone.addClass('active');
		} else {
			$clone.removeClass('active');
		}
		if(calendar && calendar.days.length >= i) {
			$clone.find('.js-day-number').text(i + ' (' + new Date(calendar.dtStart).addDays(i - 1).toISOString().substr(0, 10) + ')');
		}
		$clone.insertBefore($buttonDiv);
	}

	if (calendar) {
		//fill out the values
		for (var i = 0; i < calendar.days.length; i++) {
			Object.keys(calendar.days[i]).forEach(function (inputName) {
				var inp = $('.pulseCalendar__section input[name="' + inputName + '"]');
				inp.val([calendar.days[i][inputName]]);
				if(calendar.days[i][inputName] === 'oregelbunden') {
					$(inp[1]).closest('.radio').addClass('radio__oregelbunden--active');
				}
			});
		}
		if(calendar.days.length > 0) {
			$daySection.find('.js-day-number').text('1 (' + calendar.dtStart.substr(0, 10) + ')');
		}
	}
	//enable/disable the pagination buttons
	(function() {
		var $currEl = $('.pulseCalendar__section.active');
		if ($currEl.index() === 13) {
			$('.js-next-day').addClass('btn--disabled');
		} else if ($currEl.index() <= 1) {
			$('.js-prev-day').addClass('btn--disabled');
		}
	})();


	function saveValuesToLocalstorage(e) {
		if (e && e.preventDefault) { e.preventDefault(); }
		if (!calendar) {
			//initial time, create the basic structure
			calendar = {
				dtStart: new Date().toISOString(),
				dtLastSave: new Date().toISOString(),
				days: []
			};
		}
		calendar.days = []; //reset before re-filling
		$('.pulseCalendar__section').each(function () {
			var day = {};
			var bHasValues = false;
			$(this).find('input:checked').each(function () {
				bHasValues = true;
				var $this = $(this);
				day[$this.attr('name')] = $this.val();
				if($this.val() === 'oregelbunden') {
					$this.closest('.radio').addClass('oregelbunden--active');
				} else {
					$this.closest('.radio').siblings('.radio').removeClass('oregelbunden--active');
				}
			});
			if (bHasValues) {
				calendar.days.push(day);
			}
		});
		calendar.dtLastSave = new Date().toISOString();
		localStorage.setItem('pulse_calendar', JSON.stringify(calendar));
	}
	$('.pulseCalendar').on('change', 'input', saveValuesToLocalstorage);


	$('.js-next-day').on('click', function (e) {
		e.preventDefault();
		$('.js-prev-day').removeClass('btn--disabled');
		var $currEl = $('.pulseCalendar__section.active');
		if ($currEl.index() < 13) { //validate there is a next/prev to go to
			$currEl.removeClass('active').next().addClass('active');
		}
		if ($currEl.index() === 12) {
			$(this).addClass('btn--disabled');
		}
	});
	$('.js-prev-day').on('click', function (e) {
		e.preventDefault();
		$('.js-next-day').removeClass('btn--disabled');
		var $currEl = $('.pulseCalendar__section.active');
		if ($currEl.index() > 0) { //validate there is a next/prev to go to
			$currEl.removeClass('active').prev().addClass('active');
		}
		if ($currEl.index() <= 1) {
			$(this).addClass('btn--disabled');
		}
	});

	//TODO: Maybe a loading indicator?
	$('.js-download-pulse').on('click', function (e) {
		e.preventDefault();
		$('#pulse-print').remove();
		$('#cardio-print').remove();
		var $sections = $('.pulseCalendar__section');
		$sections.addClass('printing');
		createPDF($('.pulseCalendar')[0], function(doc) {
			doc.save('pulskalender.pdf');
			$sections.removeClass('printing');
		});
	});

	$('.js-print-pulse').on('click', function (e) {
		e.preventDefault();
		$('#pulse-print').remove();
		$('#cardio-print').remove();
		var $sections = $('.pulseCalendar__section');
		$sections.addClass('printing');
		createPDF($('.pulseCalendar')[0], function(doc) {
			doc.autoPrint();
			const hiddenPdf = document.createElement('embed');
			hiddenPdf.style.position = 'fixed';
			hiddenPdf.style.width = '1px';
			hiddenPdf.style.height = '1px';
			hiddenPdf.style.opacity = '0.01';
			hiddenPdf.setAttribute("id", "pulse-print");
			hiddenPdf.setAttribute("type", "application/pdf");
			hiddenPdf.src = doc.output('bloburl');
			document.body.appendChild(hiddenPdf);
			$sections.removeClass('printing');
		});
	});

	function createPDF(item, callback) {
		var doc = new jsPDF( {
			orientation: 'p',
			unit: 'pt',
			format: 'a4'
		});
		var heightHolder = {height: 0};//hack to "pass" the rendered height back here
		getCanvas(item, heightHolder).then(function(canvas) {
			//Split this canvas into pieces that fit into PDF pages. Then add them in the PDF
			var heightOfDay = heightHolder.height / 14;
			//We "know" we can fit 4 items onto a page PDF, so split into 4 pages
			for(var i = 0; i < 4; i++) {
				//Create a new canvas, and draw the "window" we need into that new canvas. Then add that as an image onto the page
				var cnvPage = document.createElement('canvas');
				cnvPage.height = heightOfDay * 4;
				cnvPage.width = 768;
				var ctxPage = cnvPage.getContext('2d');
				ctxPage.drawImage(canvas, 0, cnvPage.height * i, 768, cnvPage.height, 0, 0, 768, cnvPage.height);
				const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
				let scaleWidth = 595;
				if(browserZoomLevel < 100) {
					let scaledWidth = {
						90: 670,
						80: 750,
						75: 800,
						70: 830,
						67: 880,
						50: 900,
						33: 1000,
						25: 1000
					};
					scaleWidth = scaledWidth[browserZoomLevel];
				}
				doc.addImage(cnvPage.toDataURL('image/png'), 'png', 0, 0, scaleWidth, 841);
				if(i < 3) {
					doc.addPage();
				}
			}
			callback(doc);
		});


	}

	function getCanvas(container, heightHolder) {
		//Renders all of the days into a canvas
		return html2canvas(container, {
			imageTimeout: 0,
			removeContainer: true,
			logging: true,
			height: container.scrollHeight - 128, //128 being the height of div.pulseCalendar__buttons, please make more generic if possible
			windowHeight: container.scrollHeight - 128,
			windowWidth: 768, //fixed to 768 to get a consistent look
			width:768,
			x:0,
			scrollY: 0,
			y:0,
			backgroundColor: null,
			ignoreElements: function(el) {
				//Ignore all elements that aren't to be rendered
				var nodeName = el.nodeName.toLowerCase();
				if(nodeName === 'section' && el.className.indexOf('components-pulse-calendar') == -1) {return true;}
				if(nodeName === 'header' || nodeName === 'footer' || nodeName === 'script') {return true;}
				if(nodeName === 'div' && (el.id === 'consent_blackbar' || el.id === 'sprite-plyr' || el.className.indexOf('components-globals-page-navigation') > -1 || el.className.indexOf('pulseCalendar__buttons') > -1)) {return true;}
			},
			onclone: function(clonedDoc) {
				//Make some modifications: show the selected option only, rather than the radiobutton inputs
				var $main = $(clonedDoc.getElementsByTagName('main'));
				$main.removeClass('mt-1 lg:mt-5').css({
					'padding': '0px'
				});
				$main.find('.mt-2.mb-4').removeClass('mt-2 mb-4');
				//show only selected options
				$main.find('.pulseCalendar__option').each(function (i) {
					var $this = $(this);
					var opt = $this.find('input:checked');
					if(opt.length === 0) {
						//User hasn't made a choice here yet.
						opt = $($this.find('.radio__container').first());
						opt.text('Ej valt');
					} else {
						opt.hide();
					}
					var otherOpt = opt.closest('.radio').siblings('.radio');
					otherOpt.hide();
				});
				//try to make pdf look nicer if page zoom is increased
				const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
				let scaleVal = 0;
				if(browserZoomLevel > 100) {
					scaleVal = 100 - (browserZoomLevel - 100);
					let scaletext = browserZoomLevel+10;
					let headingStyle = {
						'scale': scaletext+'%',
					};
					headingStyle['margin-bottom'] = '4rem';
					headingStyle['margin-top'] = '4rem';
					if(browserZoomLevel == 150) {
						headingStyle['scale'] = '150%';
						headingStyle['max-height'] = '70px';
					}
					if(browserZoomLevel == 160) {
						headingStyle['scale'] = '160%';
						headingStyle['max-height'] = '70px';
					}
					if(browserZoomLevel == 175) {
						headingStyle['scale'] = '180%';
						headingStyle['max-height'] = '75px';
					}
					if(browserZoomLevel > 175) {
						headingStyle['scale'] = '200%';
						headingStyle['max-height'] = '80px';
					}
					let scaleValues = {
						110: 91,
						125: 80,
						150: 68,
						175: 58,
						200: 50
					};
					if($.browser.mozilla) {
						scaleValues = {
							109: 92,
							110: 92,
							120: 84,
							130: 78,
							140: 74,
							150: 68,
							158: 60,
							171: 45,
							182: 50,
							188: 50,
							200: 50
						};
					}
					$main.find('.pulseCalendar').css({
						'scale': scaleValues[browserZoomLevel]+'%',
						'transform-origin': '0 0'
					});
					$main.find('.pulseCalendar .pulseCalendar__heading').css(headingStyle);
				} else {
					$main.find('.pulseCalendar').css({
						'scale': '100%',
						'transform-origin': '0 0'
					});
				}
				//hack to "pass" the rendered height back up to image splicer
				heightHolder.height = $main.find('.pulseCalendar')[0].scrollHeight;
			}
		});
	}


});
